// =====================================================================
// SIMULATORE AI PRODIGY — DOMANDE (modificabili)
// Regole:
//  - Ogni domanda deve avere esattamente 4 risposte (tasti 1-4).
//  - L'ordine delle risposte viene mescolato a ogni sessione: scrivile nell'ordine che preferisci.
//  - "punti" è nascosto all'utente. Usa solo le sigle qui sotto (valori numerici).
//  - Per mantenere l'equilibrio: in ogni domanda le 4 risposte principali (3 punti)
//    vanno a 4 dimensioni diverse; il punto secondario (1) va a una dimensione già presente nella domanda.
// =====================================================================

// Le 6 dimensioni del grafico a radar. Non cambiare le "sigla": sono usate dal calcolo.
export const DIMENSIONI = [
  { sigla: "L", nome: "Leadership" },
  { sigla: "P", nome: "Problem Solving" },
  { sigla: "A", nome: "Adattabilità" },
  { sigla: "R", nome: "Precisione" },
  { sigla: "C", nome: "Comunicazione" },
  { sigla: "V", nome: "Creatività" },
];

export const DOMANDE = [
  {
    // 1
    domanda: "Mancano tre giorni alla consegna di un progetto di gruppo e un membro del team si ritira all'improvviso. Cosa fai?",
    risposte: [
      { testo: "Riunisco subito il gruppo e ridistribuisco i compiti in base ai punti di forza di ciascuno.", punti: { L: 3, A: 1 } },
      { testo: "Riduco il perimetro: individuo le parti davvero indispensabili e semplifico il resto.", punti: { P: 3, R: 1 } },
      { testo: "Mi prendo una parte del suo lavoro e rivedo il mio piano giorno per giorno.", punti: { A: 3 } },
      { testo: "Ricostruisco un calendario dettagliato, con controlli intermedi su ogni parte.", punti: { R: 3, P: 1 } },
    ],
  },
  {
    // 2
    domanda: "Devi presentare un'idea a persone che non conoscono l'argomento e hai solo dieci minuti. Come la imposti?",
    risposte: [
      { testo: "Parto dal loro punto di vista: cosa ci guadagnano e perché dovrebbe interessargli.", punti: { C: 3, L: 1 } },
      { testo: "Preparo una metafora o un esempio visivo che renda l'idea memorabile.", punti: { V: 3, C: 1 } },
      { testo: "Vado dritto alla proposta e chiudo chiedendo una decisione concreta.", punti: { L: 3 } },
      { testo: "Seleziono i tre dati più solidi e costruisco il ragionamento attorno a quelli.", punti: { P: 3 } },
    ],
  },
  {
    // 3
    domanda: "Chi valuta il tuo lavoro cambia i criteri a metà percorso. Come reagisci?",
    risposte: [
      { testo: "Accetto il cambio e riorganizzo il lavoro sui nuovi criteri da subito.", punti: { A: 3 } },
      { testo: "Confronto punto per punto i vecchi e i nuovi criteri per capire cosa devo rifare.", punti: { R: 3, A: 1 } },
      { testo: "Chiedo un confronto per capire le ragioni e chiarire le aspettative.", punti: { C: 3 } },
      { testo: "Lo vedo come un'occasione per proporre un approccio diverso da quello previsto.", punti: { V: 3, A: 1 } },
    ],
  },
  {
    // 4
    domanda: "Ti viene affidata, con poco preavviso, un'attività che non hai mai svolto. Qual è il tuo primo passo?",
    risposte: [
      { testo: "Accetto e cerco subito chi può affiancarmi, organizzando il lavoro insieme.", punti: { L: 3 } },
      { testo: "Scompongo l'attività in passaggi e affronto per primo quello più critico.", punti: { P: 3, R: 1 } },
      { testo: "Inizio subito, imparando mentre procedo e correggendo il tiro.", punti: { A: 3, P: 1 } },
      { testo: "Prima di iniziare raccolgo esempi, procedure e indicazioni precise.", punti: { R: 3 } },
    ],
  },
  {
    // 5
    domanda: "In una riunione o in aula nessuno prende la parola e la discussione è ferma. Cosa fai?",
    risposte: [
      { testo: "Faccio una domanda aperta a chi di solito parla meno, per coinvolgerlo.", punti: { C: 3 } },
      { testo: "Lancio un'idea volutamente provocatoria per smuovere la discussione.", punti: { V: 3, L: 1 } },
      { testo: "Riassumo la situazione e propongo un ordine dei punti da affrontare.", punti: { L: 3, C: 1 } },
      { testo: "Riformulo il problema in modo più concreto, così è più facile rispondere.", punti: { P: 3, C: 1 } },
    ],
  },
  {
    // 6
    domanda: "Lo strumento che usi ogni giorno sta per essere sostituito da uno completamente nuovo. Come ti muovi?",
    risposte: [
      { testo: "Inizio a usarlo subito, anche se all'inizio sarò più lento.", punti: { A: 3 } },
      { testo: "Preparo una lista delle funzioni che uso, per verificare che nulla vada perso nel passaggio.", punti: { R: 3 } },
      { testo: "Chiedo a chi lo usa già quali sono i trucchi e gli errori da evitare.", punti: { C: 3, A: 1 } },
      { testo: "Esploro le funzioni meno conosciute per capire cosa potrei fare di nuovo.", punti: { V: 3 } },
    ],
  },
  {
    // 7
    domanda: "Un lavoro che consideravi concluso ti torna indietro con molte correzioni. Come lo gestisci?",
    risposte: [
      { testo: "Me ne assumo la responsabilità e propongo io i tempi per la nuova versione.", punti: { L: 3 } },
      { testo: "Cerco lo schema comune dietro alle correzioni, per non ripetere lo stesso errore.", punti: { P: 3 } },
      { testo: "Rivedo il mio approccio: probabilmente serve un metodo diverso.", punti: { A: 3, P: 1 } },
      { testo: "Riprendo ogni correzione e la sistemo una per una, senza tralasciarne nessuna.", punti: { R: 3 } },
    ],
  },
  {
    // 8
    domanda: "Devi convincere un gruppo scettico ad adottare un nuovo modo di lavorare. Su cosa punti?",
    risposte: [
      { testo: "Ascolto prima i loro dubbi e costruisco la proposta partendo da quelli.", punti: { C: 3 } },
      { testo: "Propongo una prova breve e diversa dal solito: farlo vivere invece di spiegarlo.", punti: { V: 3, P: 1 } },
      { testo: "Do l'esempio per primo e mi prendo la responsabilità dei risultati.", punti: { L: 3 } },
      { testo: "Mostro con un confronto concreto quanto tempo o fatica fa risparmiare.", punti: { P: 3, C: 1 } },
    ],
  },
  {
    // 9
    domanda: "Stai lavorando a un progetto e le informazioni di partenza si rivelano incomplete. Come procedi?",
    risposte: [
      { testo: "Vado avanti con ciò che ho e aggiorno il lavoro man mano che arrivano nuovi dati.", punti: { A: 3 } },
      { testo: "Segnalo con precisione cosa manca prima di proseguire.", punti: { R: 3, C: 1 } },
      { testo: "Contatto le persone coinvolte per ricostruire il quadro completo.", punti: { C: 3 } },
      { testo: "Formulo ipotesi alternative e preparo più versioni possibili.", punti: { V: 3, A: 1 } },
    ],
  },
  {
    // 10
    domanda: "Due impegni importanti si sovrappongono nello stesso giorno. Cosa fai?",
    risposte: [
      { testo: "Decido quale ha la priorità e comunico chiaramente la scelta a chi è coinvolto.", punti: { L: 3 } },
      { testo: "Cerco un modo per gestirli entrambi, spostando o anticipando alcune parti.", punti: { P: 3, A: 1 } },
      { testo: "Resto flessibile e ricalibro la giornata in base a come evolvono le cose.", punti: { A: 3 } },
      { testo: "Pianifico la giornata nel dettaglio, lasciando margini per ogni imprevisto.", punti: { R: 3 } },
    ],
  },
  {
    // 11
    domanda: "Un compagno o un collega ti chiede un parere sincero su un lavoro poco riuscito. Come rispondi?",
    risposte: [
      { testo: "Parto da ciò che funziona e poi indico con tatto cosa migliorare.", punti: { C: 3 } },
      { testo: "Gli propongo un modo diverso di guardare il lavoro, con qualche idea per rilanciarlo.", punti: { V: 3 } },
      { testo: "Sono diretto: gli dico cosa non va e cosa farei al suo posto.", punti: { L: 3, P: 1 } },
      { testo: "Individuo il punto debole principale e gli suggerisco come risolverlo.", punti: { P: 3 } },
    ],
  },
  {
    // 12
    domanda: "Ti ritrovi in un gruppo di lavoro con persone molto diverse da te. Come ti comporti?",
    risposte: [
      { testo: "Mi adeguo ai loro ritmi e al loro modo di lavorare.", punti: { A: 3, C: 1 } },
      { testo: "Propongo regole chiare e strumenti condivisi per evitare malintesi.", punti: { R: 3 } },
      { testo: "Dedico tempo a conoscerle, per capire come comunicare con ciascuna.", punti: { C: 3 } },
      { testo: "Vedo le differenze come una risorsa e cerco idee nate dall'incontro dei punti di vista.", punti: { V: 3 } },
    ],
  },
  {
    // 13
    domanda: "Ti accorgi che un progetto di gruppo sta andando nella direzione sbagliata, ma nessuno lo dice. Cosa fai?",
    risposte: [
      { testo: "Lo dico apertamente e propongo come cambiare rotta.", punti: { L: 3 } },
      { testo: "Raccolgo elementi concreti per capire dove si è sbagliato, prima di parlarne.", punti: { P: 3, R: 1 } },
      { testo: "Adatto la mia parte di lavoro per limitare gli effetti negativi.", punti: { A: 3 } },
      { testo: "Ricontrollo con attenzione i dati per essere certo che l'errore ci sia davvero.", punti: { R: 3 } },
    ],
  },
  {
    // 14
    domanda: "Hai un'idea che potrebbe migliorare il lavoro di tutti, ma nessuno te l'ha chiesta. Come la porti avanti?",
    risposte: [
      { testo: "Ne parlo in modo informale con alcune persone per raccogliere le prime reazioni.", punti: { C: 3 } },
      { testo: "Ne realizzo un piccolo prototipo per mostrarla in concreto.", punti: { V: 3, P: 1 } },
      { testo: "La presento a chi decide e mi offro di guidarne la realizzazione.", punti: { L: 3, C: 1 } },
      { testo: "Valuto costi e benefici per capire se vale davvero la pena.", punti: { P: 3 } },
    ],
  },
  {
    // 15
    domanda: "Una scadenza viene anticipata e non c'è più il tempo di fare tutto come previsto. Cosa fai?",
    risposte: [
      { testo: "Cambio subito piano e mi concentro su ciò che si può fare davvero.", punti: { A: 3 } },
      { testo: "Taglio alcune parti, ma mantengo alta la qualità di quelle che consegno.", punti: { R: 3 } },
      { testo: "Avviso subito le persone interessate e concordo con loro le priorità.", punti: { C: 3, A: 1 } },
      { testo: "Cerco una scorciatoia creativa per ottenere lo stesso risultato con meno passaggi.", punti: { V: 3 } },
    ],
  },
  {
    // 16
    domanda: "Durante un esame, una prova pratica o un colloquio ricevi una domanda del tutto inattesa. Come reagisci?",
    risposte: [
      { testo: "Prendo un respiro e rispondo con sicurezza, guidando io il discorso.", punti: { L: 3 } },
      { testo: "Ragiono ad alta voce, scomponendo la domanda in parti più semplici.", punti: { P: 3 } },
      { testo: "La collego a qualcosa che conosco e improvviso.", punti: { A: 3 } },
      { testo: "Chiedo un chiarimento per essere sicuro di aver capito bene, prima di rispondere.", punti: { R: 3, P: 1 } },
    ],
  },
  {
    // 17
    domanda: "Devi spiegare un concetto complesso a qualcuno che non lo conosce. Come procedi?",
    risposte: [
      { testo: "Adatto linguaggio ed esempi a chi ho davanti, verificando spesso che mi segua.", punti: { C: 3 } },
      { testo: "Uso un'analogia inaspettata o uno schizzo per renderlo intuitivo.", punti: { V: 3, C: 1 } },
      { testo: "Lo guido passo dopo passo, decidendo io l'ordine dei contenuti.", punti: { L: 3 } },
      { testo: "Isolo il cuore del concetto e lascio da parte i dettagli secondari.", punti: { P: 3 } },
    ],
  },
  {
    // 18
    domanda: "Il tuo ruolo in un progetto cambia all'improvviso. Qual è la tua prima mossa?",
    risposte: [
      { testo: "Mi metto subito al lavoro sul nuovo ruolo, anche senza tutte le istruzioni.", punti: { A: 3 } },
      { testo: "Mi assicuro di passare il lavoro precedente in ordine, documentando tutto.", punti: { R: 3 } },
      { testo: "Chiarisco con il gruppo cosa si aspettano da me adesso.", punti: { C: 3, R: 1 } },
      { testo: "Colgo l'occasione per reinventare il modo in cui quel ruolo viene svolto.", punti: { V: 3, A: 1 } },
    ],
  },
  {
    // 19
    domanda: "Un'attività di gruppo è in ritardo perché una persona non rispetta gli impegni. Come intervieni?",
    risposte: [
      { testo: "Ne parlo direttamente con lei e concordiamo un nuovo impegno preciso.", punti: { L: 3 } },
      { testo: "Cerco di capire cosa la blocca davvero e come rimuovere l'ostacolo.", punti: { P: 3 } },
      { testo: "Riorganizzo il lavoro degli altri per compensare il ritardo.", punti: { A: 3, L: 1 } },
      { testo: "Introduco scadenze intermedie e verifiche regolari per tutti.", punti: { R: 3, L: 1 } },
    ],
  },
  {
    // 20
    domanda: "Devi scegliere un tema o un progetto su cui lavorare per diversi mesi. Cosa ti guida?",
    risposte: [
      { testo: "Ne parlo con persone diverse per capire cosa genera più interesse.", punti: { C: 3 } },
      { testo: "Scelgo il tema più originale, anche se è meno battuto.", punti: { V: 3 } },
      { testo: "Scelgo un progetto in cui posso avere un ruolo di guida.", punti: { L: 3 } },
      { testo: "Scelgo quello con il problema più stimolante da risolvere.", punti: { P: 3, V: 1 } },
    ],
  },
  {
    // 21
    domanda: "Ricevi un riscontro negativo inaspettato davanti ad altre persone. Come reagisci?",
    risposte: [
      { testo: "Lo accolgo con calma e modifico il mio approccio da subito.", punti: { A: 3 } },
      { testo: "Prendo nota dei punti esatti, per analizzarli con attenzione più tardi.", punti: { R: 3 } },
      { testo: "Ringrazio e chiedo un momento a parte per approfondire.", punti: { C: 3, A: 1 } },
      { testo: "Lo uso come spunto per ripensare il lavoro da un'angolazione nuova.", punti: { V: 3 } },
    ],
  },
  {
    // 22
    domanda: "Durante un evento, una presentazione o un'attività importante qualcosa va storto all'ultimo minuto. Cosa fai?",
    risposte: [
      { testo: "Prendo in mano la situazione e do indicazioni chiare a tutti.", punti: { L: 3, A: 1 } },
      { testo: "Individuo in pochi secondi l'alternativa più semplice e la applico.", punti: { P: 3, A: 1 } },
      { testo: "Improvviso con calma, adattando il programma a ciò che è disponibile.", punti: { A: 3 } },
      { testo: "Attivo il piano B che avevo preparato proprio per questi casi.", punti: { R: 3 } },
    ],
  },
  {
    // 23
    domanda: "Nel tuo gruppo nasce un conflitto tra due persone con idee opposte. Come ti comporti?",
    risposte: [
      { testo: "Faccio parlare entrambe e riformulo i loro punti per trovare ciò che le unisce.", punti: { C: 3 } },
      { testo: "Propongo una terza strada che combini elementi di entrambe le idee.", punti: { V: 3, P: 1 } },
      { testo: "Ascolto entrambe e poi prendo una decisione per sbloccare il lavoro.", punti: { L: 3 } },
      { testo: "Riporto il confronto sui fatti e su criteri oggettivi per scegliere.", punti: { P: 3 } },
    ],
  },
  {
    // 24
    domanda: "Hai completato un lavoro importante in anticipo rispetto alla scadenza. Come usi il tempo che resta?",
    risposte: [
      { testo: "Mi rendo disponibile per aiutare dove serve in quel momento.", punti: { A: 3, C: 1 } },
      { testo: "Ricontrollo tutto un'ultima volta, con calma.", punti: { R: 3 } },
      { testo: "Condivido il risultato con chi è coinvolto per raccogliere un primo riscontro.", punti: { C: 3 } },
      { testo: "Aggiungo un elemento in più che renda il lavoro davvero distintivo.", punti: { V: 3 } },
    ],
  },
];
